import React from "react";

export default class WatermarkOverlay extends React.Component {
  state = {
    windowWidth: window.innerWidth
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize.bind(this));
  }

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  updateWatermarkPlacement(watermarkStyle, top, right, bottom, left) {
    watermarkStyle.top = top;
    watermarkStyle.right = right;
    watermarkStyle.bottom = bottom;
    watermarkStyle.left = left;
    return watermarkStyle;
  }

  get watermarkStyle() {
    let playerHeight;
    let playerWidth;
    let height;
    let width;
    let watermarkHeight;
    let scaleFactor;
    let left;
    let top;

    if (document.getElementById("vid") && this.props.watermarkHeight) {
      playerHeight = document.getElementById("vid").offsetHeight - 31;
      playerWidth = document.getElementById("vid").offsetWidth;
      scaleFactor = this.props.watermarkScaleFactor;
      height =
        playerHeight * (this.props.watermarkHeight / this.props.videoHeight);
      watermarkHeight = height.toString() + "px";

      let width = height * scaleFactor;
      left = ((playerWidth - width) / 2).toString() + "px";
      top = ((playerHeight - height) / 2).toString() + "px";
    }

    let watermarkStyle = {
      opacity: this.props.opacity * ".01",
      width: "auto",
      height: watermarkHeight
    };

    switch (this.props.selectedGridBox) {
      case 0:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "0px",
          "",
          "",
          "0px"
        );
        return watermarkStyle;
      case 1:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "0px",
          "",
          "",
          left
        );
        return watermarkStyle;
      case 2:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "0px",
          "0px",
          "",
          ""
        );
        return watermarkStyle;
      case 3:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          top,
          "",
          "",
          "0px"
        );
        return watermarkStyle;
      case 4:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          top,
          "",
          "",
          left
        );
        return watermarkStyle;
      case 5:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          top,
          "0px",
          "",
          ""
        );
        return watermarkStyle;
      case 6:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "",
          "",
          "32px",
          "0px"
        );
        return watermarkStyle;
      case 7:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "",
          "",
          "32px",
          left
        );
        return watermarkStyle;
      case 8:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "",
          "0px",
          "32px",
          ""
        );
        return watermarkStyle;
      case 9:
        watermarkStyle = this.updateWatermarkPlacement(
          watermarkStyle,
          "",
          "32px",
          "32px",
          ""
        );
        return watermarkStyle;
      case "full":
        let margin =
          ((playerWidth - playerHeight * scaleFactor) / 2).toString() + "px";
        let maxHeight = playerHeight.toString() + "px";
        watermarkStyle.width = "auto";
        watermarkStyle.height = maxHeight;
        watermarkStyle.marginLeft = margin;
        return watermarkStyle;
      default:
        watermarkStyle.display = "none";
        return watermarkStyle;
    }
  }

  render() {
    return (
      <img
        id="watermark-overlay"
        src={this.props.src}
        className={this.props.className}
        style={this.watermarkStyle}
      />
    );
  }
}
